function initMobileSubmenus() {
	const menuDrawer = document.querySelector('.f-drawer-mobile-nav')
	if (!menuDrawer || menuDrawer.dataset.submenuNavigationReady === 'true') return

	menuDrawer.dataset.submenuNavigationReady = 'true'

	const resetSubmenus = () => {
		menuDrawer.querySelectorAll('[data-mobile-submenu].is-open').forEach((panel) => {
			panel.classList.remove('is-open')
			panel.setAttribute('aria-hidden', 'true')
		})
		menuDrawer.querySelectorAll('[data-mobile-submenu-trigger]').forEach((trigger) => {
			trigger.setAttribute('aria-expanded', 'false')
		})
	}

	menuDrawer.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-mobile-submenu-trigger]')
		const back = event.target.closest('[data-mobile-submenu-back]')
		if (!trigger && !back) return

		event.preventDefault()
		event.stopPropagation()

		if (trigger) {
			const owner = trigger.parentElement
			const panel = owner?.querySelector(':scope > [data-mobile-submenu]')
			if (!panel) return

			trigger.setAttribute('aria-expanded', 'true')
			panel.setAttribute('aria-hidden', 'false')
			panel.classList.add('is-open')
			panel.scrollTop = 0
			window.setTimeout(() => {
				panel.querySelector('[data-mobile-submenu-back]')?.focus()
			}, 300)
			return
		}

		const panel = back.closest('[data-mobile-submenu]')
		const owner = panel?.parentElement
		const ownerTrigger = owner?.querySelector(':scope > [data-mobile-submenu-trigger]')

		panel?.querySelectorAll('[data-mobile-submenu].is-open').forEach((childPanel) => {
			childPanel.classList.remove('is-open')
			childPanel.setAttribute('aria-hidden', 'true')
		})
		panel?.querySelectorAll('[data-mobile-submenu-trigger]').forEach((childTrigger) => {
			childTrigger.setAttribute('aria-expanded', 'false')
		})
		panel?.classList.remove('is-open')
		panel?.setAttribute('aria-hidden', 'true')
		ownerTrigger?.setAttribute('aria-expanded', 'false')
		window.setTimeout(() => ownerTrigger?.focus(), 300)
	}, true)

	menuDrawer.addEventListener('close', resetSubmenus)
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initMobileSubmenus)
} else {
	initMobileSubmenus()
}
